<div class="row mb-3">
    <div class="col-md-9 text-end">
            <p class="mb-1 mt-1 mr-2 text-success" *ngIf="showUpdated"><i class="fas fa-check"></i> Updated</p>
    </div>
    <div class="col-md-3 text-end">
        <app-user-company-add [isEditMode]="isEditMode"
                              [userId]="userId"
                              (userCompanyAdded)="onUserCompanyAdded($event)">
        </app-user-company-add>
    </div>
</div>

<section class="panel">
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Trading Name</th>
                        <th>User Type</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody *ngFor="let company of companies;index as i">
                    <tr>
                        <td>{{i+1}}</td>
                        <td>{{company.legalName}}</td>
                        <td>{{company.tradingName}}</td>
                        <td>
                            <ng-container *ngIf="!isEditMode">{{company.userTypeDescription}}</ng-container>
                            <ng-container *ngIf="isEditMode">
                                <select id="userTypeId" name="userTypeId" class="form-select" (change)="updateCompanyUserType(company, $event.target.value)">
                                    <option *ngFor="let userType of userTypes" [value]="userType.id" [selected]="company.userTypeId==userType.id">{{ userType.description}}</option>
                                </select>
                            </ng-container>
                        </td>
                        <td class="actions text-center">
                            <a (click)="selectedCompanyUserId=company.id; confirmation.showMessage()" title="Delete Company" class="mb-1 mt-1 me-2 text-primary" *ngIf="isEditMode"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteCompanyUser()"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this company?'">
</app-confirmation-message>
